module.exports = __webpack_public_path__ + "img/lock-outline.8a54df18.svg";